<template lang="html">
    <div class="tab w-min-full xl:w-full" v-show="isActive">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Tab'
        },
        enabled: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            isActive: true
        }
    }
}
</script>
